export default function calculatePrice({
  discount,
  stats,
  variety,
}: {
  discount: number;
  stats: API.MembershipProductStats;
  variety: API.MembershipProductOffer;
  // relatedProducts?: API.MembershipProduct[];
}) {
  const plays =
    variety.auto && variety.plays - stats.played > 0 ? variety.plays - stats.played : variety.plays;
  const basePrice = variety.price || 0;
  const originalPrice = Math.ceil(
    variety.auto ? (((basePrice * 100) / variety.plays) * plays) / 100 : basePrice,
  );
  let price = Math.ceil(originalPrice * (1 - discount));

  // @todo need to look up all products and check if it has auto on the main item
  // We should probably split this off into something on the API and let it get cached
  if (variety.combos) {
    for (const combo of variety.combos) {
      price += Math.ceil((combo.price || 0) * (1 - discount));
    }
  }

  if (variety.addOn) {
    price += Math.ceil((variety.addOn.price || 0) * (1 - discount));
  }

  return { originalPrice, plays, price };
}
